var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "92px",
    height: "80px",
    viewBox: "0 0 92 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Loop-Optimise",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LO-connect---solar-diverter-warning",
    transform: "translate(-674, -149)",
    fill: "#FF0085"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M719.707695,149 C722.243409,149 724.582695,150.339286 725.868409,152.535714 L764.439838,218.25 C765.743409,220.464286 765.743409,223.196429 764.475552,225.410714 C763.207695,227.625 760.832695,229 758.279123,229 L681.136266,229 C678.582695,229 676.207695,227.625 674.939838,225.410714 C673.67198,223.196429 673.689838,220.446429 674.975552,218.25 L713.54698,152.535714 C714.832695,150.339286 717.17198,149 719.707695,149 Z M724.378472,206 L715.711806,206 C714.899306,206 714.222222,206.677083 714.222222,207.489583 L714.222222,216.065972 C714.222222,216.878472 714.899306,217.555556 715.711806,217.555556 L724.378472,217.555556 C725.145833,217.555556 725.777778,216.878472 725.777778,216.065972 L725.777778,207.489583 C725.777778,206.677083 725.145833,206 724.378472,206 Z M724.965278,171.333333 L715.034722,171.333333 C714.628472,171.333333 714.222222,171.46875 713.951389,171.694444 C713.635417,171.875 713.5,172.190972 713.5,172.506944 L714.267361,200.538194 C714.267361,201.170139 714.944444,201.666667 715.802083,201.666667 L724.152778,201.666667 C724.965278,201.666667 725.642361,201.170139 725.6875,200.538194 L726.5,172.506944 C726.5,172.190972 726.364583,171.875 726.048611,171.694444 C725.777778,171.46875 725.371528,171.333333 724.965278,171.333333 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.67d8086bc2fe8af164a6bdfb165af234.svg";
export { ForwardRef as ReactComponent };